import { useContext } from "react";
import { ScrollableDocumentUpdateContext } from "../customContext/scrollableDocumentProvider";

export function useUpdateScrollableDocumentCtx(){
    const ctx = useContext(ScrollableDocumentUpdateContext);
    if(ctx == null){
        throw new Error('scrollableDocumentUpdateContext must be used within scrollableDocumentProvider context')
    };
    return ctx
}